export default [
    {
        type: "selection",
        width: 38,
        align: "center",
    },
    {
        title: 'Assigned Roles',
        key: 'RoleName',
        minWidth: 80,
    },

]
